import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import filteredObjectsSelector from 'functions/filteredObjectsSelector'
import { objectsToArray, sortArrayBy } from 'functions/utilities'

import * as campaignProposalSectionActions from 'agency/redux/modules/campaignProposalSection'

const sortSections = (sections) => {
  const array = objectsToArray(sections)
  return sortArrayBy(array, 'asc', 'sort')
}

const getDataSourceIdKey = dataSourceType => (dataSourceType === 'CampaignProposal' ? 'campaign_proposal_id' : 'digital_page_id')

const createSection = (props) => {
  const { dataSource, createCampaignProposalSection, dataSourceType } = props

  const section = {
    campaign_proposal_id: dataSource.id,
    title: 'New Section',
  }

  const dataSourceIdKey = getDataSourceIdKey(dataSourceType)
  section[dataSourceIdKey] = dataSource.id

  const createFn = dataSourceType === 'CampaignProposal' ? createCampaignProposalSection : null
  createFn(section)
}

const CustomSectionsWrapper = (props) => {
  const { customSections, creatingSection, render } = props

  const sortedSections = sortSections(customSections)

  return render({
    createSection: () => createSection(props),
    creatingSection,
    sections: sortedSections,
  })
}

CustomSectionsWrapper.propTypes = {
  render: PropTypes.func.isRequired,
}

function mapStateToProps(state, props){
  const { dataSource, dataSourceType } = props

  const customSections = filteredObjectsSelector(
    state,
    dataSourceType === 'CampaignProposal' ? 'campaignProposalSections' : 'digitalPageSections',
    getDataSourceIdKey(dataSourceType),
    dataSource.id,
  )

  return {
    customSections,
    creatingSection: state.campaignProposalSections.creating,
  }
}

const mapDispatchToProps = {
  createCampaignProposalSection: campaignProposalSectionActions.createCampaignProposalSection,
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomSectionsWrapper)
